export default __webpack_public_path__ + "static/media/MilindNimse.3464cfa6.png";